module.exports = __webpack_public_path__ + "img/lens-174-minus-03.36e21eb0.png";